import * as React from 'react';
import { useContext } from 'react';

import user from 'js/lib/user';

import FrontPage from 'bundles/front-page/components/FrontPage';
import { getInternationalizationVariables } from 'bundles/front-page/utils';
import RouterContext from 'bundles/page/contexts/RouterContext';
import type { OverrideRule } from 'bundles/seo/types';

export type Props = {
  seoOverrideRule?: OverrideRule[];
  isPreview: boolean;
};

// This layer is where all data for SSR should be fetched along with basic page setup like header/footer/index style file.
// After this point no data meant to be rendered on server should be requested.
const FrontPageWrapper: React.FC<Props> = (props) => {
  const { location } = useContext(RouterContext);
  const previewParam = location?.query?.preview;
  const isPreview = !!user.isSuperuser() && !!previewParam && Number(previewParam) === 1;

  const { countryCode, languageCode } = getInternationalizationVariables(location.pathname);

  return <FrontPage {...props} countryCode={countryCode} languageCode={languageCode} isPreview={isPreview} />;
};

export default FrontPageWrapper;
